import * as React from 'react';
var PrivateContext = /*#__PURE__*/React.createContext({});
export { PrivateContext as default };
//# sourceMappingURL=PrivateContext.js.map
